import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSave, faSearch, faArrowUp, faArrowDown, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Reinforcement.css';
import '../../Shared/Searchbar.css'; // Import your CSS file
import axios from "axios"
import GoCast from '../../Images/GoCast.png'
import { css } from '@emotion/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ReinforcementDet() {

    const [searchOpen, setSearchOpen] = useState(false);
    const [tableVisible, setTableVisible] = useState(true);
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [modifiedData, setModifiedData] = useState([]); // New state for modified data
    const [modifiedRows, setModifiedRows] = useState(new Set()); // New state to track modified rows
    const [filter, setFilter] = useState(''); // Element ID Filter

    const [isLoading, setIsLoading] = useState(false); // Loading GIF

    //ADD 
    const [showEmptyRow, setShowEmptyRow] = useState(false);
    const [job, setjob] = useState('');
    const [elementid, setelementid] = useState('');
    const [reinforcementid, setreinforcementid] = useState('');
    const [reinforcementdescription, setreinforcementdescription] = useState('');
    const [qty, setqty] = useState('');
    const [uom, setuom] = useState('');
    const [unit, setunit] = useState('');
    const [engineered, setengineered] = useState(false);
    const [released, setreleased] = useState(false);
    const [site, setsite] = useState(false);

    const handleFilterChange = (e) => {
        const inputValue = e.target.value.toLowerCase(); // Convert input value to lowercase
        setFilter(inputValue);

        // Filter apiData based on the input value, ensuring ElementID is defined
        const filteredData = apiData.filter(item => item.PartLot_LotNum && item.PartLot_LotNum.toLowerCase().includes(inputValue));
        setModifiedData(filteredData.map(item => ({ ...item }))); // Update modifiedData with filtered data
    };

    const fetchData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager';
        const password = 'manager';
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_RebarElements_PCopy(PRECAST)';

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
                setModifiedData(data.value.map(item => ({ ...item }))); // Initialize modifiedData with the fetched data
                setIsLoading(false); // Loading GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const saveData = async () => {
        const username = 'manager';
        const password = 'manager';
        if (showEmptyRow) {
            const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UD102Svc/UD102s`;
            // console.log(CheckBox01)
            // if (CheckBox01 === "on") {
            //     console.log("dakhal")
            //     setCheckBox01(true)
            // }
            // else {
            //     console.log("madakhalsh")
            // }
            // console.log(CheckBox01)
            const newRow = {
                "Company": "PRECAST",
                "JobHead_JobNum": job,
                "PartLot_LotNum": elementid,
                "JobMtl_PartNum": reinforcementid,
                "JobMtl_Description": reinforcementdescription,
                "JobMtl_QtyPer": qty,
                "JobHead_IUM": uom,
                "JobHead_ProdQty": unit,
                "JobHead_JobEngineered": engineered,
                "JobHead_JobReleased": released,
                "JobMtl_Plant": site
            };
            console.log(newRow)
            try {
                const response = await axios.post(apiUrl, newRow, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                setShowEmptyRow(false)
                console.log('Data saved successfully:', response.data);
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
            } catch (error) {
                console.error('Error:', error.message);
                // Toast Notifcation
                setTimeout(() => {
                    toast.error("Failed To Save");
                }, 10);
            }

        }
        else {
            setIsLoading(true); // Loading GIF
            const username = 'manager';
            const password = 'manager';
            const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_RebarElements_PCopy(PRECAST)';

            try {
                for (const rowIndex of modifiedRows) {
                    const response = await axios.patch(apiUrl, modifiedData[rowIndex], {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic ' + btoa(username + ":" + password)
                        }
                    });
                    console.log('Data saved successfully:', response.data);
                    setIsLoading(false); // Loading GIF
                    // Toast Notifcation
                    setTimeout(() => {
                        toast.success("Data Saved Successfully");
                    }, 10);
                }
            } catch (error) {
                console.error('Error:', error.message);
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.error("Failed To Save");
                }, 10);
            }
        }
    };

    const handleInputChange = (e, index, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const newData = [...modifiedData];
        newData[index][field] = newValue;
        setModifiedData(newData);
        setModifiedRows(new Set(modifiedRows.add(index))); // Add the index to modifiedRows set
    };

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, modifiedData.length); // Use modifiedData.length
        const currentItems = modifiedData.slice(startIndex, endIndex);

        return (
            <>
                {currentItems.map((item, index) => (
                    <tr key={startIndex + index}> {/* Adjust key to ensure uniqueness */}
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_JobNum} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_JobNum')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].PartLot_LotNum} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_LotNum')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_PartNum} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_PartNum')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_Description} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_Description')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_QtyPer} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_QtyPer')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_IUM} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_IUM')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_ProdQty} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_ProdQty')} /></td>
                        <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobEngineered} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_JobEngineered')} /></td>
                        <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobReleased} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_JobReleased')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_Plant} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_Plant')} /></td>
                    </tr>

                ))}
                {/* Add input fields for the empty row */}
                {showEmptyRow && (
                    currentItems.slice(startIndex, endIndex).map((item, index) => (
                        <tr key={`empty-row-${index}`}>
                            <td><input className='UpdateInput' type="text" placeholder="Job Num" value={modifiedData[startIndex + index].JobHead_JobNum} onChange={(e) => setjob(e, startIndex + index, 'JobHead_JobNum')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Element ID " value={modifiedData[startIndex + index].PartLot_LotNum} onChange={(e) => setelementid(e, startIndex + index, 'PartLot_LotNum')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Reinfocement ID" value={modifiedData[startIndex + index].JobMtl_PartNum} onChange={(e) => setreinforcementid(e, startIndex + index, 'JobMtl_PartNum')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Reinforcement Description" value={modifiedData[startIndex + index].JobMtl_Description} onChange={(e) => setreinforcementdescription(e, startIndex + index, 'JobMtl_Description')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Wty/Per" value={modifiedData[startIndex + index].JobMtl_QtyPer} onChange={(e) => setqty(e, startIndex + index, 'JobMtl_QtyPer')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="UOM" value={modifiedData[startIndex + index].JobHead_IUM} onChange={(e) => setuom(e, startIndex + index, 'JobHead_IUM')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Unit/Each" value={modifiedData[startIndex + index].JobHead_ProdQty} onChange={(e) => setunit(e, startIndex + index, 'JobHead_ProdQty')} /></td>
                            <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobEngineered} onChange={(e) => setengineered(e, startIndex + index, 'JobHead_JobEngineered')} /></td>
                            <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobReleased} onChange={(e) => setreleased(e, startIndex + index, 'JobHead_JobReleased')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Site" value={modifiedData[startIndex + index].JobMtl_Plant} onChange={(e) => setsite(e, startIndex + index, 'JobMtl_Plant')} /></td>
                        </tr>
                    ))
                )}
            </>
        );
    };


    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }

    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }
    const addNewRow = () => {
        console.log("Add button clicked!");
        // Create a new row with default values or with values based on your requirements
        const newRow = {
            JobHead_JobNum: '',
            PartLot_LotNum: '',
            JobMtl_PartNum: '',
            JobMtl_Description: '',
            JobMtl_QtyPer: '',
            JobHead_IUM: '',
            JobHead_JobEngineered: true,
            JobHead_JobReleased: true,
            JobMtl_Plant: '',
        };
        setShowEmptyRow(true);
        // Add the new row to the modifiedData state
        setModifiedData([...modifiedData, newRow]);
        // Also, update the apiData state if needed
        setApiData([...apiData, newRow]);
    };
    return (
        <div className='card rebartable'>
            <div className='card rebar'>
            <ToastContainer />
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className="card-header">
                {/* <button type="button" className="toggle-table-icon" onClick={() => setTableVisible(!tableVisible)}>
                    <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                </button> */}
                <div className='panelTitlDiv-reinf'>
                    <h3 className='panel-title-rebardet'>Hardware List</h3>
                </div>
                {/* <div className='Element-id-container-rebar'>
                    <input type='text' placeholder=' Element ID' className='Elementidinput-rebar' onChange={handleFilterChange} />
                </div>

                  
                </div> */}
            </div>
            {tableVisible && (
                <div className="card-body">
                    <div className="table-responsive">
                        <div className="scrollable-table-body">
                            <table className="table table-bordered">
                                <thead className='table-primary'>
                                    <tr className='bg-primary text-white'>
                                        <th>No.</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                        <th>Plant ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {renderTableRows()} */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="pagination">
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                </div>
            )}
            </div>
            <div className='card rebar1'>
            <ToastContainer />
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className="card-header">
                {/* <button type="button" className="toggle-table-icon" onClick={() => setTableVisible(!tableVisible)}>
                    <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                </button> */}
                <div className='panelTitlDiv-reinf'>
                    <h3 className='panel-title-rebardet'>Reinforcement List</h3>
                </div>

                {/* <div className='Element-id-container-rebar'>
                    <input type='text' placeholder=' Element ID' className='Elementidinput-rebar' onChange={handleFilterChange} />
                </div>

                <div className='ctrl-btns-rebar'>
                    <button className="btn" id='save' onClick={saveData}>
                        <FontAwesomeIcon icon={faSave} />
                    </button>
                    <Tooltip
                        anchorSelect="#save"
                        content="Save"
                        place='bottom'
                    />
                  
                </div> */}
            </div>
            {tableVisible && (
                <div className="card-body">
                    <div className="table-responsive">
                        <div className="scrollable-table-body">
                            <table className="table table-bordered">
                                <thead className='table-primary'>
                                    <tr className='bg-primary text-white'>
                                        <th>No.</th>
                                        <th>E/F</th>
                                        <th>Type</th>
                                        <th>Shape</th>
                                        <th>o/c</th>
                                        <th>Length</th>
                                        <th>B</th>
                                        <th>C</th>
                                        <th>Plant ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {renderTableRows()} */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="pagination">
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                </div>
            )}
            </div>
        </div>
    );
}

export default ReinforcementDet;